import { Controller } from "@hotwired/stimulus"

// Opcjonalna textarea w ustawieniach (partial account/settings/_setting_textarea).
// Pusta - zamiast niej widać przełącznik (wiersz `empty`), dopiero włączenie go odsłania pole (wiersz `filled`)
// z kursorem w środku. Pole zostawione puste (blur) znów chowa się za przełącznikiem.
// Zapis robi samo pole (onchange -> IntumJs.setField), kontroler tylko przełącza widok.
export default class extends Controller {
  static targets = ["empty", "filled", "field"]

  // włączenie przełącznika - pokaż pole i ustaw w nim kursor
  reveal() {
    this.show(true)
    setTimeout(() => this.fieldTarget.focus(), 0)
  }

  // wyjście z pola - puste wraca do przełącznika
  collapseIfBlank() {
    if (this.isBlank(this.fieldTarget.value)) this.show(false)
  }

  show(filled) {
    this.emptyTarget.classList.toggle("hidden", filled)
    this.filledTarget.classList.toggle("hidden", !filled)
  }

  // same spacje i puste linie to też brak wartości (słowniki zapisują linie jako listę)
  isBlank(value) {
    return (value || "").trim() === ""
  }
}
